var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "videoPage" }, [
    this.$store.state.webNavigator == "pc"
      ? _c("div", [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.pageType,
                  expression: "pageType"
                }
              ]
            },
            [
              _c("twoLevelList", {
                attrs: {
                  titles: _vm.titles,
                  twolist: _vm.navLsit,
                  tltType: _vm.twolist ? "1" : "2",
                  act: _vm.active ? _vm.active : "",
                  classCode: _vm.classType,
                  toLeveListPath: _vm.toLeveListPath
                },
                on: { twoType: _vm.clickType }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "doctorvideo-list" },
            _vm._l(_vm.videolist, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "displayIB positionRE pointEr doctorvideo-bar",
                  on: {
                    click: function($event) {
                      return _vm.getvideo(item.videoUrl, item.title)
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "doctorvideo-backimg",
                    attrs: {
                      src: _vm.httptype(item.coverImg),
                      alt: item.title,
                      title: ""
                    }
                  }),
                  _c("img", {
                    staticClass: "video-start positionAB video-min-start",
                    attrs: { src: _vm.src1, alt: "", title: "" }
                  }),
                  _c(
                    "p",
                    { staticClass: "col666666 doctorvideo-Tlt overflowText" },
                    [_vm._v(_vm._s(item.title))]
                  )
                ]
              )
            }),
            0
          )
        ])
      : _vm._e(),
    this.$store.state.webNavigator == "phone"
      ? _c("div", [
          _c(
            "div",
            {
              staticClass: "videoPhone-listBox",
              class: _vm.titles != "案例视频" ? "" : "videoPhone-BoxBack"
            },
            [
              _c(
                "div",
                [
                  _c("twoLevelList", {
                    attrs: {
                      titles: _vm.titles,
                      twolist: _vm.navLsit,
                      tltType: _vm.twolist ? "1" : "2",
                      act: _vm.active ? _vm.active : "",
                      classCode: _vm.classType,
                      toLeveListPath: _vm.toLeveListPath
                    },
                    on: { twoType: _vm.clickType }
                  })
                ],
                1
              ),
              _vm.titles != "案例视频"
                ? _c(
                    "div",
                    { staticClass: "videoPhone-list" },
                    _vm._l(_vm.videolist, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass:
                            "videoPhone-listBar displayIB positionRE",
                          on: {
                            click: function($event) {
                              return _vm.getvideoPhone(item)
                            }
                          }
                        },
                        [
                          _c("div", [
                            _c("img", {
                              staticClass: "videoPhone-listImg",
                              attrs: {
                                src: _vm.httptype(item.coverImg),
                                alt: item.title,
                                title: ""
                              }
                            }),
                            _c("div", {
                              staticClass: "videoPhone-goto positionAB"
                            })
                          ]),
                          _c("div", [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "videoPhone-listP overflowText font22phone col666666"
                              },
                              [_vm._v(_vm._s(item.title))]
                            )
                          ])
                        ]
                      )
                    }),
                    0
                  )
                : _c(
                    "div",
                    { staticClass: "videoPhone-list" },
                    _vm._l(_vm.videolist, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "phone-videoBox",
                          on: {
                            click: function($event) {
                              return _vm.getvideoPhone(item)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "phone-ImgBox positionRE" },
                            [
                              _c("img", {
                                staticClass: "phone-videoImg",
                                attrs: {
                                  src: _vm.httptype(item.coverImg),
                                  alt: item.title,
                                  title: ""
                                }
                              }),
                              _c("div", {
                                staticClass: "phone-playImg positionAB"
                              })
                            ]
                          ),
                          _c("div", { staticClass: "phone-videoTlt" }, [
                            _vm._v(_vm._s(item.title))
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "font24phone col99999 phone-videoTip"
                            },
                            [
                              _c("span", {
                                staticClass: "Time-down displayIB"
                              }),
                              _c("span", { staticClass: "text-down" }, [
                                _vm._v(" " + _vm._s(item.createdAt) + "    ")
                              ]),
                              _c("span", { staticClass: "see-down displayIB" }),
                              _c("span", { staticClass: "text-down" }, [
                                _vm._v(" " + _vm._s(item.playNum))
                              ])
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pageLength < _vm.count,
                      expression: "pageLength<count"
                    }
                  ],
                  staticClass: "phone-more col33333 font22phone marginAuto",
                  on: {
                    click: function($event) {
                      return _vm.getMore()
                    }
                  }
                },
                [_vm._v("\n        加载更多\n      ")]
              )
            ]
          )
        ])
      : _vm._e(),
    _c(
      "div",
      [
        _c("playVideo", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.playVideoType,
              expression: "playVideoType"
            }
          ],
          attrs: { videoPlay: _vm.videoPlay, videoTlt: _vm.videoTlt },
          on: { funcVideo: _vm.downvideo }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65fc3ee4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65fc3ee4","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/listPage/videoPage/videoPage.vue
// module id = 878
// module chunks = 7 8